import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { Input } from "@itandi/itandi-bb-ui/Input";
import { useFormContext } from "react-hook-form";
import type { MarketCompanySetting } from "~/models/CompanySetting";
import Styles from "./Form.module.scss";

type Props = DeepReadonly<{
	isConfirm?: boolean;
}>;

export function StaffForm({ isConfirm = false }: Props) {
	const { register, getValues, formState } =
		useFormContext<MarketCompanySetting>();
	const values = getValues();
	const { errors } = formState;
	return (
		<div className={Styles.FormGroup}>
			<div className={Styles.GroupLabel}>担当者情報</div>
			<div className={Styles.FormList}>
				<div className={Styles.FormBlock}>
					<div className={Styles.FormLabel}>
						氏名
						{!isConfirm && <span className={Styles.RequireLabel}>必須</span>}
					</div>
					<div className={Styles.FormContent}>
						{isConfirm ? (
							<span>{values.staffName}</span>
						) : (
							<Input
								isInvalid={!!errors.staffName}
								placeholder="例）内装 太郎"
								{...register("staffName")}
							/>
						)}
						{errors.staffName ? (
							<div className={Styles.ErrorMessage}>
								{errors.staffName.message}
							</div>
						) : null}
					</div>
				</div>
				<div className={Styles.FormBlock}>
					<div className={Styles.FormLabel}>
						メールアドレス
						{!isConfirm && <span className={Styles.RequireLabel}>必須</span>}
					</div>
					<div className={Styles.FormContent}>
						{isConfirm ? (
							<span>{values.staffEmail}</span>
						) : (
							<Input
								isInvalid={!!errors.staffEmail}
								placeholder="例）itandi.tarou@example.com"
								{...register("staffEmail")}
							/>
						)}
						{errors.staffEmail ? (
							<div className={Styles.ErrorMessage}>
								{errors.staffEmail.message}
							</div>
						) : null}
					</div>
				</div>
				<div className={Styles.FormBlock}>
					<div className={Styles.FormLabel}>
						電話番号
						{!isConfirm && <span className={Styles.RequireLabel}>必須</span>}
					</div>
					<div className={Styles.FormContent}>
						{isConfirm ? (
							<span>{values.staffPhoneNumber}</span>
						) : (
							<Input
								isInvalid={!!errors.staffPhoneNumber}
								placeholder="例）070-1234-5678"
								{...register("staffPhoneNumber")}
							/>
						)}
						{errors.staffPhoneNumber ? (
							<div className={Styles.ErrorMessage}>
								{errors.staffPhoneNumber.message}
							</div>
						) : null}
					</div>
				</div>
			</div>
		</div>
	);
}
